export class EnquiryPackBomModel{
    id: number;
    itemCategoryId: number
    itemCategory: string
    itemSubCategoryId: number
    itemSubCategory: string
    itemId: number
    itemName: string
    quantity: number
    enquiryId: number
    constructor(
        id: number,
        itemCategoryId: number,
        itemCategory: string,
        itemSubCategoryId: number,
        itemSubCategory: string,
        itemId: number,
        itemName: string,
        quantity: number,
        enquiryId: number
        ){
        this.id = id
        this.itemCategoryId = itemCategoryId
        this.itemSubCategoryId = itemSubCategoryId
        this.itemId = itemId
        this.quantity = quantity
        this.enquiryId = enquiryId
        this.itemCategory = itemCategory
        this.itemSubCategory = itemSubCategory
        this.itemName = itemName
    }
}